import { getMjmlFonts } from '@wix/wix-emails-commons';
import posthtml from 'posthtml/lib';
import { getUnformattedFontDisplayName } from './utils/getUnformattedFontDisplayName';
import { isSystemFont } from './utils/isSystemFont';
export const addFontsToHead = mjml => {
  const fonts = getMjmlFonts(mjml, {
    Ubuntu: {
      displayName: 'Ubuntu',
      cssFontFamily: 'Ubuntu',
      supportedInHtmlEmails: true
    }
  });
  const webFonts = fonts.filter(font => !isSystemFont(font.displayName));
  const fontData = webFonts.map(font => {
    const unformattedDisplayName = getUnformattedFontDisplayName(font.displayName) || font.displayName;
    const nameForLink = unformattedDisplayName.replaceAll(' ', '+');
    return {
      ...font,
      unformattedDisplayName,
      nameForLink
    };
  });
  const mjFontElements = fontData.map(font => ({
    tag: 'mj-font',
    attrs: {
      name: font.displayName,
      href: `https://static.parastorage.com/tag-bundler/api/v1/fonts-cache/googleAPI/css?family=${font.nameForLink}:n,b,i,bi&display=swap`
    }
  }));
  const appendFonts = tree => {
    tree.match({
      tag: 'mj-head'
    }, node => {
      if (!node.content) {
        node.content = [];
      }
      mjFontElements.forEach(element => node.content.push(element));
      return node;
    });
    return tree;
  };
  const withFonts = posthtml([appendFonts]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withFonts.html;
};
//# sourceMappingURL=add-fonts-to-head.js.map